import { compact, flatten } from 'lodash'
import { IDB_units, IDB_dexieDB } from '../IDB/IDB.dexie'
import { I18N_replaceNameSlug, I18N_replaceNameSlugs } from '../I18N/I18N.slugs'
import type { KnownUnit } from '../../../app-core/lib/unit/unit'
import type { ClientLogger } from '../../../shared/lib/ClientLogger.no-deps'
import { IDB_unitTypeRead } from '../IDB/IDB.table.unitType'
import { Maybe } from '@zaptic-external/ts-monads'
import type { AppUnitType } from '../../../shared/domain/units/types.no-deps'

export async function Unit_fetchForTypes(unitTypes: number[]): Promise<KnownUnit[]> {
    // Using `anyOf()` doesn't seem to be faster than multiple parallel `.equal()` calls with a large units count.
    return Promise.all(unitTypes.map((type) => IDB_units().where('type').equals(type).toArray()))
        .then(flatten)
        .then(I18N_replaceNameSlugs)
        .then((units) => units.filter((unit) => !unit.isDeleted))
}

export async function Unit_fetchByIds(unitIds: number[]) {
    return IDB_dexieDB.transaction('r', IDB_units(), async () => {
        return IDB_units().bulkGet(unitIds).then(compact).then(I18N_replaceNameSlugs)
    })
}

/**
 * AVOID using this function.
 *
 * This function can potentially take hundreds thousands units into memory which is
 * very bad for performance.
 *
 * @deprecated
 */
export async function Unit_all(): Promise<KnownUnit[]> {
    return IDB_units().toArray()
}

export async function Unit_fetchById(logger: ClientLogger, unitId: number) {
    const [unit] = await Unit_fetchByIds([unitId])

    if (unit == null) {
        logger.warn(`failed to find unit`, { unitId })
    }

    return unit
}

export async function UnitType_fetchById(unitTypeId: number): Promise<AppUnitType | null> {
    return IDB_unitTypeRead(unitTypeId)
}

export async function UnitType_fetchNameById(unitTypeId: number): Promise<Maybe<string>> {
    const unitType = await IDB_unitTypeRead(unitTypeId)
    return Maybe.just(I18N_replaceNameSlug(unitType).name)
}

export async function UnitType_fetchByIds(unitTypeIds: number[]) {
    return IDB_dexieDB.transaction('r', IDB_units(), async () => {
        return Promise.all(unitTypeIds.map(IDB_unitTypeRead)).then(compact).then(I18N_replaceNameSlugs)
    })
}
